import {
    GET_USER_DATA,
    GET_ADD_USER_DATA,
    GET_USER_COMPANY,
    GET_DATA_COMPANY,
    SUCCESS_MESSAGE_USER,
    ERROR_MESSAGE_USER,
    HIDE_MESSAGE_USER,
} from 'constants/ActionTypes';


let INIT_STATE = {
    alertMessageUser: '',
    successMessageUser: false,
    errorMessageUser: false,
    userData: [],
    userCompany: [],
    dataCompany: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_USER_DATA: {
            return {
                ...state,
                userData: action.payload
            }
        }
        case GET_ADD_USER_DATA: {
            return {
                ...state,
                userData: [...state.userData, action.payload]
            }
        }
        case GET_USER_COMPANY: {
            return {
                ...state,
                userCompany: action.payload
            }
        }
        case GET_DATA_COMPANY: {
            return {
                ...state,
                dataCompany: action.payload
            }
        }
        case SUCCESS_MESSAGE_USER: {
            return {
                ...state,
                alertMessageUser: action.payload,
                successMessageUser: true,
            }
        }
        case ERROR_MESSAGE_USER: {
            return {
                ...state,
                alertMessageUser: action.payload,
                errorMessageUser: true,
            }
        }
        case HIDE_MESSAGE_USER: {
            return {
                ...state,
                alertMessageUser: '',
                errorMessageUser: false,
                successMessageUser: false,
            }
        }
        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/User.js